import { ref, push, set, query, orderByChild, startAt, endAt, get } from 'firebase/database';
import { db } from '../lib/firebase';

export interface ActivityLog {
  id?: string;
  userId: string;
  userName: string;
  activityType: string;
  word?: string | null;
  pointsEarned: number;
  timestamp: number;
}

export const logUserActivity = async (
  userId: string,
  userName: string,
  activityType: string,
  pointsEarned: number,
  word?: string
) => {
  if (pointsEarned <= 0) return; // Only log point-earning activities for challenges
  
  const logRef = push(ref(db, `activityLogs/${userId}`));
  await set(logRef, {
    userId,
    userName,
    activityType,
    word: word || null,
    pointsEarned,
    timestamp: Date.now()
  });
};

export const fetchChallengeLogs = async (
  userIds: string[],
  startTime: number,
  endTime: number
): Promise<ActivityLog[]> => {
  const allLogs: ActivityLog[] = [];

  for (const userId of userIds) {
    if (!userId) continue;
    
    const logsQuery = query(
      ref(db, `activityLogs/${userId}`),
      orderByChild('timestamp'),
      startAt(startTime),
      endAt(endTime)
    );
    
    const snapshot = await get(logsQuery);
    if (snapshot.exists()) {
      const data = snapshot.val();
      for (const [id, log] of Object.entries<ActivityLog>(data)) {
        allLogs.push({ id, ...log });
      }
    }
  }

  // Sort descending by timestamp
  return allLogs.sort((a, b) => b.timestamp - a.timestamp);
};
